/** Stable key for a training row in the configure-deployment modal. */
export function buildTaskKey(training) {
  return `${training.llm_usecase_id}:${training.version}`;
}
